export const SELECTED_SCHEME_DETAILS = "SELECTED_SCHEME_DETAILS";
export const SEED_SCHEME_DETAILS = "SEED_SCHEME_DETAILS";
export const GRM_FARMER_DETAILS = "GRM_FARMER_DETAILS";
export const USER_PROFILE = "USER_PROFILE";
